/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import { useTypedSelector } from 'helpers/reducers'
import { driverName } from 'utils/driverUtils'

export const useCurrentUser = () => {
    const session = useTypedSelector((state) => state.sessionState.session)
    const user = session?.user

    const fullName = user ? driverName(user) : ''
    const isAuthenticated = !!user

    return {
        user,
        fullName,
        isAuthenticated,
        session,
    }
}
